const dashboard = {
    page_title: 'แดชบอร์ด',
    title: 'แดชบอร์ด',
    description: 'ดูภาพรวมเกี่ยวกับประสิทธิภาพของแอปของคุณ',
    total_users: 'ผู้ใช้ทั้งหมด',
    total_users_tip: 'ผู้ใช้ทั้งหมด',
    new_users_today: 'ผู้ใช้ใหม่วันนี้',
    new_users_today_tip: 'จำนวนผู้ใช้ใหม่ที่ลงทะเบียนในแอปของคุณวันนี้',
    new_users_7_days: 'ผู้ใช้ใหม่ใน 7 วันที่ผ่านมา',
    new_users_7_days_tip: 'จำนวนผู้ใช้ใหม่ที่ลงทะเบียนในแอปของคุณใน 7 วันที่ผ่านมา',
    daily_active_users: 'ผู้ใช้ที่ใช้งานต่อวัน',
    daily_active_users_tip: 'จำนวนผู้ใช้ไม่ซ้ำที่มีการแลกเปลี่ยนโทเค็นในแอปของคุณวันนี้',
    weekly_active_users: 'ผู้ใช้ที่ใช้งานต่อสัปดาห์',
    weekly_active_users_tip: 'จำนวนผู้ใช้ไม่ซ้ำที่มีการแลกเปลี่ยนโทเค็นในแอปของคุณใน 7 วันที่ผ่านมา',
    monthly_active_users: 'ผู้ใช้ที่ใช้งานต่อเดือน',
    monthly_active_users_tip: 'จำนวนผู้ใช้ไม่ซ้ำที่มีการแลกเปลี่ยนโทเค็นในแอปของคุณใน 30 วันที่ผ่านมา',
};
export default Object.freeze(dashboard);
